import { useEffect, useState } from 'react';
import Navbar from './Navbar';
import KassirSidebar from './KassirSidebar';
import AdminSidebar from './AdminSidebar';
import LicenseNotice from './LicenseNotice';
import api from '../api/axios';
import useAuthStore from '../store/authStore';
import { useQrOrders } from '../context/QrOrdersContext';

const Layout = ({ children }) => {
    const { token, user } = useAuthStore();
    const isKassir   = user?.role === 'kassir';
    const isAdmin    = user?.role === 'admin' || user?.role === 'superadmin';
    const isWaiter   = user?.role === 'waiter';
    const hasSidebar = isKassir || isAdmin;

    const [sidebarOpen, setSidebarOpen] = useState(false);

    // Floating QR button only for roles without a sidebar (waiter pages using Layout)
    const showQrFloat = isWaiter;
    const { qrCount, openModal } = useQrOrders() || {};

    useEffect(() => {
        if (!token) return undefined;
        const ping = () => api.post('/auth/session-ping').catch(() => {});
        ping();
        const interval = setInterval(ping, 60000);
        return () => clearInterval(interval);
    }, [token]);

    return (
        <div className={`min-h-screen bg-gray-50 ${hasSidebar ? 'md:pl-64' : ''}`}>
            {/* Left sidebar — kassir or admin */}
            {isKassir && <KassirSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />}
            {isAdmin  && <AdminSidebar  open={sidebarOpen} onClose={() => setSidebarOpen(false)} />}

            {/* Mobile hamburger button — only visible when sidebar exists */}
            {hasSidebar && (
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="fixed top-3 left-3 z-30 md:hidden flex items-center justify-center w-9 h-9 rounded-xl bg-white border border-slate-200 shadow-sm text-slate-600 text-lg"
                    aria-label="Menyu aç"
                >
                    ☰
                </button>
            )}

            {/* Lisenziya bitməyə az qalanda xəbərdarlıq (yalnız tenant admini) */}
            {isAdmin && <LicenseNotice />}

            {/* Top navbar — only for roles without a sidebar (waiter, anbardar) */}
            {!hasSidebar && <Navbar />}

            <main className={`mx-auto max-w-7xl px-3 sm:px-4 lg:px-6 lg:py-6 ${hasSidebar ? 'pt-14 pb-3 sm:pb-5 md:py-3' : 'py-3 sm:py-5'}`}>
                {children}
            </main>

            {/* Floating QR button for waiter role (sidebars have it built-in) */}
            {showQrFloat && (
                <button
                    type="button"
                    onClick={openModal}
                    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-2xl bg-orange-500 px-4 py-3 text-sm font-bold text-white shadow-lg hover:bg-orange-600 transition-all"
                >
                    <span className="text-base">📲</span>
                    <span>QR Sifarişlər</span>
                    {qrCount > 0 && (
                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-[11px] font-black text-orange-600 animate-pulse">
                            {qrCount}
                        </span>
                    )}
                </button>
            )}
        </div>
    );
};

export default Layout;
